
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-76f5f338\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./context.scss")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./context.ts"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-76f5f338\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./context.vue.html"),
  /* scopeId */
  "data-v-76f5f338",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/context/context.vue.html
// module id = x1yY
// module chunks = 2